export default "__VITE_ASSET__W7tXnzvk__"